export default "__VITE_ASSET__szX5lrtv__"